module.exports = __webpack_public_path__ + "static/GraySopot-f8bc6115bd91d24ec0a590966e423e6c.svg";